import { EnvironmentName, HomeConfig, ProductName } from "situview-webapi-client";

export class CompleteHomeConfig {
  constructor(public homeConfig: HomeConfig, public environment: EnvironmentName, public productName?: ProductName, public valid?: boolean, public artifactId?: string) {
    if (valid === undefined) valid = false;
  }
}